// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"a38d7803","256":"8afa79e2","443":"d93c1d29","511":"57558cde","669":"16432155","754":"32215c2e","784":"5928e562","803":"690131bf","836":"dae808a3","869":"b22fd686","930":"6f71d0e6","948":"26fabdc0"}[chunkId] + ".chunk.js";
};